import { render, staticRenderFns } from "./Header.User.vue?vue&type=template&id=643d53f1&scoped=true&"
import script from "./Header.User.vue?vue&type=script&lang=js&"
export * from "./Header.User.vue?vue&type=script&lang=js&"
import style0 from "./Header.User.vue?vue&type=style&index=0&id=643d53f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d53f1",
  null
  
)

export default component.exports